function updateIconsForTheme(pageTheme) {
    console.log("[updateIconsForTheme] Running with theme:", pageTheme);
    const iconElements = document.querySelectorAll("[data-icon]");
    iconElements.forEach((element) => {
        const forcedTheme = element.getAttribute("data-force-theme");
        const finalTheme = forcedTheme || pageTheme;

        const iconSet = finalTheme === "dark" ? darkThemeIcons : lightThemeIcons;
        const iconName = element.getAttribute("data-icon");

        if (iconSet && iconSet.hasOwnProperty(iconName)) {
            console.log("  - Setting src for", iconName, "to", iconSet[iconName]);
            element.setAttribute("src", "/" + iconSet[iconName]);
        } else {
            console.warn(`⚠ Icon not found for: ${iconName} in theme: ${finalTheme}`);
        }
    });
}

function applyTheme() {
    const globalForce = window.forceTheme;
    const pageTheme =
        globalForce || document.documentElement.getAttribute("theme") || "light";

    console.log("[applyTheme] Current page theme is:", pageTheme);
    updateIconsForTheme(pageTheme);
}

// Expose globally
window.applyTheme = applyTheme;
window.updateIconsForTheme = updateIconsForTheme;

// Run once on DOM load
document.addEventListener("DOMContentLoaded", applyTheme);
